export class Structure {
    static jsonMap = {
        id: 'id',
        code: { key: 'code', optional: true, default: '' },
        libelle: { key: 'libelle', optional: true, default: '' }
    };

    public id: number;
    public code: string;
    public libelle: string;
}
